// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Zk130","gradient":"Button_gradient__-hgi6","normal":"Button_normal__AxN3O","transparent":"Button_transparent__W3oyp"};